import React from 'react'
import denormalize from 'json-api-denormalizer'
import { connect } from 'react-redux'
import { mod,toggleValueInList, defineQuestTypes, getLocalDate } from '../../util'
import { runQuery } from '../../fetchUtils'
import _, { assign } from 'lodash'
import ImageHeader from '../../components/ImageHeader'
import Calendar from './Calendar'
import LegendPills from '../../components/LegendPills'
import FilterBanner from '../../components/FilterBanner'
import AssignmentPopupContainer from '../../containers/AssignmentPopupContainer/index'
import QuestInfoPanel from './QuestInfoPanel'
import AssignmentInfoPanel from './AssignmentInfoPanel'
import { getSandboxName, getSandboxQuestDescription } from '../../util'

//importing related to onboarding guide
import {OnboardingGuideBanner} from '../../components/OnboardingHomepage'
import { OnboardingTeacherContext } from '../../contexts/OnboardingTeacherContextProvider'

import tippsGreetingImage from '../../assets/img/Tipps_Greeting.png'
import calendarHeaderImage from '../../assets/img/CalendarHeaderImage.png'
import ImageEmptyState from '../../components/ImageEmptyState'
import '../../assets/css/pages/calendar/index.css'

export const routes = [
  '/calendar'
]

class CalendarContainer extends React.Component {
  constructor(props) {
    super(props);
    this.selectedTagElement = React.createRef();
    this.state = {
      calendarLoaded: false,
      sidebarLoaded: false,
      showInfoPanel: false,
      isAssignmentPopupVisible: false,
      usingDeletionForm: false,
      calendarData: {
        uniqueDailyAssignments:[],
        expeditionAssignments:[]
      },
      infoPanelData: {},
      calendarErrors: [],
      deletePriorLoading: false, //set loadingAnimation
      deletePriorErrors: [],
      deletePriorCount: '', // Number of assignments deleted by delete prior mutation, set to a string initially to differentiate when the mutation has been ran
      selectedDate: '',
      selectedAssignmentGrouping: {},
      filterSelectedCourseIds: [],
      filterSelectedSectionIds: [],
      filterSelectedStudentIds: [],
      filterSelectedContentTypes: [],
      filterCommittedCourseIds: [],
      filterCommittedSectionIds: [],
      filterCommittedStudentIds: [],
      filterCommittedContentTypes: [],
      assignments: [],
      sequences: [],
      eduModules: [],
      studentGroupings: {},
      popupQuestData: {},
      defaultAssignees: [],
      meMode: false
    }
  }

  componentDidMount() {
    this.fetchCalendarData(
      this.state.filterCommittedCourseIds,
      this.state.filterCommittedSectionIds,
      this.state.filterCommittedStudentIds,
      this.state.filterCommittedContentTypes
    )
  }

  responseErrors(json) {
    if (json.errors) {
      return json.errors.map(e => e.message)
    } else if (json.error) {
      return [json.error]
    }

    return []
  }

  //GraphQL Mutations and Queries

  fetchCalendarData(filteredCourseIds, filteredSectionIds, filteredStudentIds,filteredContentTypes, fetchMyAssignments = false) {
    const fetchExpeditionType  = () =>{
      return _.isEmpty(filteredContentTypes) || _.includes(filteredContentTypes,'expedition')
    }

    const calendarLoadQuery=`
      query calendarLoadQuery($courseIds: [ID!], $sectionIds: [ID!], $studentIds: [ID!], $contentTypes: [String!], $includeSelfAssignments: Boolean, $includeStudentAssignments: Boolean){
        uniqueDailyAssignments(courseIds: $courseIds, sectionIds: $sectionIds, studentIds: $studentIds, contentTypes: $contentTypes, includeSelfAssignments: $includeSelfAssignments, includeStudentAssignments: $includeStudentAssignments){
          id
          createdAt
          questId
          userId
          toBeAssignedAt
          studentId
          contentTypeId
          sectionAssignmentId
          orderingFingerprint
          sectionAssignment {
            sectionId
          }
          quest{
            name
            eduModuleId
            eduModuleUnlockId
            sandboxQuestDescription: inGameDescription
            sandboxUnlockModule{
              sandboxName
            }
            ngssEnrichment
          }
        }
        sequences{
          id
          sequenceQuests{
            questId
            rank
          }
        }
        ${!fetchExpeditionType() ? '': 'expeditionAssignments(courseIds: $courseIds, sectionIds: $sectionIds, studentIds: $studentIds, isSelfAssignment: $includeSelfAssignments)'}
        courses{
          name
          id
          sections{
            name
            id
            students{
              id
              profile{
                firstName
                lastName
              }
            }
          }
        }
      }
    `
    const vars = {
      courseIds:                  filteredCourseIds,
      sectionIds:                 filteredSectionIds,
      studentIds:                 filteredStudentIds,
      contentTypes:               filteredContentTypes,
      includeSelfAssignments:     fetchMyAssignments,
      includeStudentAssignments:  !fetchMyAssignments
    }
    const callbacks = {
      onComplete: json => {
        const errors = this.responseErrors(json)
        if(!_.isEmpty(errors)) {
          this.setState({
            calendarLoaded: true,
            calendarData:   {},
            calendarErrors: errors
          }, () => console.log('errors with fetch: ', errors))
        }
        else {
        //NOTE: expedition errors are separated since expedition assignments are managed on a different service, and an error on expedition fetch should not block the display of regular quests
        const expeditionErrors = fetchExpeditionType() && json.data.expeditionAssignments[0]?.errors
        if(!_.isEmpty(expeditionErrors)){
          console.log(`expedition assignments: ${expeditionErrors}`)
        }
       
        const expeditionAssignments = (!_.isEmpty(expeditionErrors) || !fetchExpeditionType() ? [] : json.data.expeditionAssignments.Items).map((expeditionVersion) => {
          const firstExpeditionInstance = expeditionVersion.expedition_instances[0]
          const isSelfAssignment = json.data.expeditionAssignments.is_self_assignment

          return {
            classId: isSelfAssignment? 0 : expeditionVersion.class_id,
            sectionName: expeditionVersion.class_name, 
            toBeAssignedAt: firstExpeditionInstance.assigned_at,
            createdAt: firstExpeditionInstance.created_at,
            isSandboxUnlock: false,
            moduleId: null, //temp, expedition data might have related module in future updates
            key: expeditionVersion.expedition_id,
            contentType: 'expedition',
            expeditionId: expeditionVersion.expedition_id,
            expeditionVersion: expeditionVersion.expedition_version,
            isSelfAssignment:isSelfAssignment,
            name: expeditionVersion.expedition_name,
            description: expeditionVersion.expedition_description,
            assignments: expeditionVersion.expedition_instances.map((expeditionInstance) => {
                return {
                  createdAt: expeditionInstance.created_at,
                  id: expeditionInstance.expedition_instance_id,
                  quest: {
                    name: expeditionVersion.expedition_name,
                    description: expeditionVersion.expedition_description
                  },
                  ...isSelfAssignment? {userUuid: expeditionInstance.user_uuid}:{students: expeditionInstance.students}
                }
            })
          }
        })
          this.setState({
            calendarLoaded: true,
            calendarData:   {...json.data, expeditionAssignments: expeditionAssignments},
            calendarErrors: [],
            selectedDate: '',
            selectedAssignmentGrouping: {},
            showInfoPanel: false
          })
        }
      },
      onFailure: error => this.setState({ calendarErrors: [error] }, () => console.log('error with fetch: ', error))
    }
    runQuery(calendarLoadQuery,vars, callbacks)
  }


  fetchInfoPanelData(questId, date, sequenceId, fetchMyAssignments = false) {
    const fetchInfoPanelDataQuery =`
      query FetchInfoPanelData($questId: ID!,  $date: String, $sequenceId: ID, $showCompleted: Boolean, $includeSelfAssignments: Boolean, $includeStudentAssignments: Boolean){
        quest(id: $questId){
          name
          educationalDescription
          sandboxQuestDescription: inGameDescription
          eduModuleUnlockId
          sandboxUnlockModule{
            moduleName: name
            sandboxName
          }
        }
        sequences{
          title
          teachingGuideLink
          quests{
            name
            id
            educationalDescription
            ngssPes
            ngssCccs
            ngssDcis
            ngssSeps
          }
        }
        eduModules{
          id
          name
          sandboxDescription
          sandboxActivities{
            title
            driveLink
          }
        }
        assignments(questId: $questId, date: $date,
                    showCompleted: $showCompleted, includeSelfAssignments: $includeSelfAssignments,
                    includeStudentAssignments: $includeStudentAssignments){
          id
          sectionAssignmentId
          sectionAssignment {
            id
            sectionId
          }
          studentId
          questId
          userId
          toBeAssignedAt
          completedAt
          student{
            profile{
              firstName
              lastName
            }
          }
        }
        sequenceAssignments: assignments(sequenceId: $sequenceId){
          id
          questId
        }
      }
    `
    const variables = {
      questId:                    questId,
      date:                       date,
      sequenceId:                 sequenceId,
      showCompleted:              true,
      includeSelfAssignments:     fetchMyAssignments,
      includeStudentAssignments:  !fetchMyAssignments
    }
    const callbacks = {
      onComplete: json => {
        const errors = this.responseErrors(json)
        if(!_.isEmpty(errors)) {
          this.setState({
            infoPanelData:   {},
            sidebarLoaded: true,
            calendarErrors: errors
          }, () => console.log('errors with fetch: ', errors))
        } else {
          this.setState({
            infoPanelData: json.data,
            sidebarLoaded: true,
            calendarErrors: []
          })
        }
      },
      onFailure: error => this.setState({ calendarErrors: [error] }, () => console.log('error with fetch: ', error))
    }

    runQuery(fetchInfoPanelDataQuery, variables, callbacks)
  }

  fetchAssignmentPopupData(selectedAssignments, usingDeletion) {
    //TODO: check if this query is necessary at all, the data that is being fetched for can also be queried
    //in fetchInfoPanelData. Since user must click on the assignment tag first before the buttons for
    //assignment deletion and change become available, so the setState for quest data can happen in the
    //fetchInfoPanelData. Setting isAssignmentPopupVisible shoud happen as a function call that is triggered
    //when the buttons are called on respectively, usingDeleteForm should be set in this function call as well.
    //(This would belong in a larger refactor, since it would lead to changes in the onClick functions and
    // how relavant states are propagated down)
    const fetchInfoPanelDataQuery =`
      query FetchAssignmentPopupData($ID: ID!){
        quest(id: $ID){
          id
          educationalDescription
          ngssPes
          ngssCccs
          ngssDcis
          ngssSeps
        }
      }
    `
    const variables = { "ID": selectedAssignments[0].questId }
    const callbacks = {
      onComplete: json => {
        const errors = this.responseErrors(json)
        if(!_.isEmpty(errors)) {
          this.setState({
            calendarErrors: errors
          }, () => console.log('errors with fetch: ', errors))
        } else {
          this.setState((state)=>{
            const quest = selectedAssignments[0].quest
            const isSandboxAssignment = !_.isNull(selectedAssignments[0].quest.eduModuleUnlockId)
            quest.id = json.data.quest.id
            quest.educationalDescription = isSandboxAssignment ?
                                            getSandboxQuestDescription(
                                              selectedAssignments[0].quest.sandboxQuestDescription,
                                              selectedAssignments[0].quest.sandboxUnlockModule.sandboxName
                                            ):json.data.quest.educationalDescription
            quest.ngssPes = json.data.quest.ngssPes
            quest.ngssCccs = json.data.quest.ngssCccs
            quest.ngssDcis = json.data.quest.ngssDcis
            quest.ngssSeps = json.data.quest.ngssSeps
            quest.type = isSandboxAssignment? 'modules' : 'quests'
            quest.name = isSandboxAssignment?
                          getSandboxName(selectedAssignments[0].quest.sandboxUnlockModule.sandboxName,quest.name):
                          quest.name
            switch(selectedAssignments[0].contentType){
              case 'enrichment':
                quest.questType = 'Enrichment Quest'
                break;
              case 'sandbox-unlock':
                quest.questType = 'Sandbox Unlock'
                break;
              case 'storyline':
                quest.questType = 'Sequence Quest'
                break;
              default:
                quest.questType = 'Practice Quest'
                break;
            }
            return{
              isAssignmentPopupVisible: true,
              usingDeletionForm: usingDeletion,
              popupQuestData: quest,
              defaultAssignees: this.formatDefaultAssignees(this.state.infoPanelData.assignments)
            }
          })
        }
      },
      onFailure: error => console.log('error with fetch: ', error)
    }

    runQuery(fetchInfoPanelDataQuery, variables, callbacks)
  }

  deletePriorAssignments = (fetchCalendarData, filterCommittedCourseIds, filterCommittedSectionIds, filterCommittedStudentIds, filterCommittedContentTypes) => {
    const mutation_string =`
      mutation DeletePriorAssignments($date: String!, $onlySelf: Boolean!) {
        deletePriorAssignments(onlySelf: $onlySelf, date: $date){
          errors
          deletedAssignments
        }
      }
    `
    this.setState({deletePriorLoading:true})
    const callbacks = {
      onComplete: json => {
        //const errors = this.responseErrors(json) This should work, but doesn't and i dont want to spend too much time on this right now
        const errors = json.error ? json.error : json.data.deletePriorAssignments.errors
        this.setState({deletePriorLoading: false})
        if(!_.isEmpty(errors)) {
          this.setState({ deletePriorErrors: errors })
        } else {
          const deletePriorCount = JSON.parse(json.data.deletePriorAssignments.deletedAssignments).length
          this.setState({deletePriorCount: _.isNumber(deletePriorCount) ? deletePriorCount : undefined})
          fetchCalendarData(filterCommittedCourseIds, filterCommittedSectionIds, filterCommittedStudentIds, filterCommittedContentTypes, this.state.meMode)
        }
      },
      onFailure: error => console.log('error with fetch: ', error)
    }

    runQuery(mutation_string, {onlySelf: this.state.meMode, date: getLocalDate()}, callbacks)
  }

  //formatting functions for assignment data
  getCalendarAssignments(data, committedCourseIds, committedSectionIds, committedStudentIds, committedContentTypes) {
    const assignments = this.state.selectedAssignmentGrouping
    const sequences = data.sequences
    let selectedSequenceQuests = []
    let filteredAssignments = data.uniqueDailyAssignments || []
    const expeditionAssignments = data.expeditionAssignments || []

    _.map(filteredAssignments, assignment => {

      switch(assignment.contentTypeId){
        case 1:
          assignment.contentType = 'practice'
          break;
        case 2:
          assignment.contentType = 'enrichment'
          break;
        case 3:
          assignment.contentType = 'sandbox-unlock'
          break;
        case 4:
          assignment.contentType = 'storyline'
          break;
        case 5:
          assignment.contentType = 'unprocessable'
          break;
      }

      if(assignment.contentType === 'storyline'){
        _.map(sequences, sequence => {if(_.find(sequence.sequenceQuests, sequenceQuest => sequenceQuest.questId === assignment.questId)){
          selectedSequenceQuests = sequence.sequenceQuests
          assignment.sequenceId = parseInt(sequence.id)
        }})
        const associatedQuestRank = _.find(selectedSequenceQuests, sequenceQuest => sequenceQuest.questId === assignment.questId).rank
        assignment.sequenceRank = associatedQuestRank
        switch (associatedQuestRank){
          case 1:
            assignment.sequenceOrder = 'first'
            break;
          case selectedSequenceQuests.length:
            assignment.sequenceOrder = 'last'
            break;
          default:
            assignment.sequenceOrder = 'middle'
            break;
        }
      }
    })
    const groupedAssignments = _.groupBy([...filteredAssignments,...expeditionAssignments], a => [a?.questId|| a?.expeditionId ,(a.toBeAssignedAt.split('T')[0]),a?.eduModuleId, a?.classId].join())
    const finalizedAssignments = _.map(groupedAssignments, (assignments,key) =>{
      const assignmentsByOrderedBy = _.orderBy(assignments, assignment => assignment.createdAt)
      const earliestCreatedAtTimestamp = assignments[0].createdAt
      return {
        key,
        title: (assignments[0].quest || assignments[0] || {}).name,
        moduleId: (assignments[0].quest || {})?.eduModuleId,
        isSandboxUnlock: assignments[0].contentType === 'expedition'? false : !_.isNull(assignments[0].quest.eduModuleUnlockId),
        createdAt: earliestCreatedAtTimestamp,
        assignedAt: assignments[0].toBeAssignedAt,
        contentType: assignments[0].contentType || {},
        sequenceId: assignments[0].sequenceId || 0,
        sequenceRank: assignments[0].sequenceRank || {},
        sequenceOrder: assignments[0].sequenceOrder || {},
        assignments
      }})

    return finalizedAssignments
  }

  getSidebarAssignments() {
    if(_.isEmpty(this.state.selectedAssignmentGrouping)){return {}}

    const data = this.state.infoPanelData
    const studentGroupings = this.state.calendarData.courses

    const selectedAssignmentGrouping = this.state.selectedAssignmentGrouping.assignments
    const allGroupedAssignments = _.groupBy(data.sequenceAssignments, assignment => assignment.questId)
    const selectedQuestInfo = data.contentType === 'expedition'? data.assignments[0] : data.quest
    const sequences = data.sequences

    let classAssignmentStudentData = []
    let selfAssignmentStudentData = []
    let individualAssignmentStudentData = []

    let classAssignmentsGroupedBySection = []
    let selectedSequence = {}


    if(selectedAssignmentGrouping[0].contentType === 'storyline') {
      _.map(sequences, sequence => {
        if(_.find(sequence.quests, quest => quest.id === selectedAssignmentGrouping[0].questId)){
          selectedSequence = sequence
          _.map(selectedSequence.quests, quest => {
            if(_.find(Object.keys(allGroupedAssignments), assignmentQuestId => parseInt(assignmentQuestId) === quest.id)){
              quest.assignmentCount = allGroupedAssignments[quest.id].length
            }
          })
        }
      })
    }

    //if sequence quest, attach quest list in the sequence
    let formattedAssignments = _.map(data.assignments, assignment => {
      _.map(studentGroupings, course => _.map(course.sections, section => {
        _.map(section.students, student => {
          if(student.id === assignment.studentId) {
            assignment.courseId = course.id
            assignment.courseName = course.name
            assignment.sectionName = section.name
            assignment.firstName = student.profile.firstName
            assignment.lastName = student.profile.lastName
          }
        })
      }))

      return {
        id: assignment.id,
        studentId: assignment.studentId,
        firstName: assignment.firstName,
        lastName: assignment.lastName,
        questId: assignment.questId,
        sectionId: (assignment.sectionAssignment || {}).sectionId,
        sectionName: assignment.sectionName,
        courseId: assignment.courseId,
        courseName: assignment.courseName,
        assignmentDate: assignment.toBeAssignedAt.split('T')[0],
        isCompleted: !_.isEmpty(assignment.completedAt),
        isClassAssignment: _.isNumber(assignment.sectionAssignmentId),
        isSelfAssignment: assignment.contentType==='expedition'? assignment.isSelfAssignment : assignment.userId === this.props.currentUser.uuid
      }
    })

    _.map(formattedAssignments, assignment => {
      if(assignment.isClassAssignment) {
        classAssignmentStudentData.push(assignment)
      } else if(assignment.isSelfAssignment) {
        selfAssignmentStudentData.push(assignment)
      } else {
        individualAssignmentStudentData.push(assignment)
      }
    })

    const classAssignmentsGroupedByCourse = _.groupBy(classAssignmentStudentData, assignment => assignment.courseId)
    _.map(classAssignmentsGroupedByCourse, (course, key) => {
      const courseGroupedBySection = _.groupBy(course, assignment =>{
        return assignment.sectionId
      })

      const courseGroupedWithoutCompletes = []
      _.map(courseGroupedBySection, (assignments, sectionId) => {
        if(!_.isEmpty(_.filter(assignments, assignment => !assignment.isCompleted))) {courseGroupedWithoutCompletes.push(assignments)}
      })
      if(!_.isEmpty(courseGroupedWithoutCompletes)){ classAssignmentsGroupedBySection.push(courseGroupedWithoutCompletes) }
    })

    let formattedSidebarAssignment = {}
    if (!_.isEmpty(data)) {
      if(data.contentType === 'expedition'){
        const selectedAssignments = selectedQuestInfo.assignments.map((assignmentGroup, groupIndex) => {
          const assignment = {
            assignmentDate:selectedQuestInfo.toBeAssignedAt.split('T')[0],
            courseId:null, //this value prob shouldn't be null, but it is not returned from lambda nor does dynamo db store this,
            courseName:'TBD: not stored in db', //this value prob shouldn't be null, but it is not returned from lambda nor does dynamo db store this,
            isClassAssignment:selectedQuestInfo.isSelfAssignment,
            isCompleted:false, //by default false, depends on if this value is returned from expedition service
            isSelfAssignment: selectedQuestInfo.isSelfAssignment,
            questId:null,
            sectionId:selectedQuestInfo.classId,
            sectionName:selectedQuestInfo.sectionName,
            groupIndex:groupIndex,
            contentType:data.contentType
          }
          return selectedQuestInfo.isSelfAssignment
            ?[{...assignment,userUuid:assignmentGroup.userUuid}]
            :assignmentGroup.students.map(student =>({
            ...assignment,
            fullName:student.full_name,
            id:student.id
          }))
        })

        formattedSidebarAssignment = {
          title:selectedQuestInfo.name,
          description: selectedQuestInfo.description,
          contentType:data.contentType,
          ...selectedQuestInfo.classId === 0? {selectedSelfAssignments:selectedAssignments} : {selectedClassAssignments:[selectedAssignments]}
        }     
      }
      else{
        formattedSidebarAssignment = ({
          title: (selectedQuestInfo || {}).name,
          description: !_.isNull(selectedQuestInfo.eduModuleUnlockId)? selectedQuestInfo.sandboxQuestDescription : (selectedQuestInfo || {}).educationalDescription,
          contentType: (selectedAssignmentGrouping || {})[0].contentType || {},
          selectedSequenceQuests: (selectedSequence || {}).quests,
          selectedSequenceTitle: (selectedSequence || {}).title,
          module: {
            ...data.quest.sandboxUnlockModule,
            sandboxActivities: data.eduModules.reduce((sandboxActivity,eduModule) => {
              eduModule.id === data.quest.eduModuleUnlockId && sandboxActivity.push(...eduModule.sandboxActivities)
              return sandboxActivity
            },[])
          },
          sequenceTeachingLink: (selectedSequence || {}).teachingGuideLink,
          selectedSelfAssignments: selfAssignmentStudentData,
          selectedClassAssignments: Object.values(classAssignmentsGroupedBySection) || {},
          selectedIndividualAssignments: _.filter(individualAssignmentStudentData, assignment => !assignment.isCompleted) || {},
          isSandbox: selectedAssignmentGrouping[0].contentType === 'sandbox-unlock'
        })
      }
    }
    return formattedSidebarAssignment
  }
  //Overflow and Aesthetic-related functions

  numberOverflowing = (containerId, tagClassName) => {
    //get the container height
    const container = document.getElementById(containerId)
    const minHeight = container.clientHeight
    const maxHeight = container.scrollHeight
    const tagHeight = document.getElementsByClassName(tagClassName)[0].scrollHeight + 8 //includes padding

    return  Math.ceil( (maxHeight - minHeight)/tagHeight )

  }

  //filter-related callbacks
  getFilterCourseCollection = ()=>
    _.map(this.state.calendarData.courses, course =>({ value: course.id, label: course.name }))
  getFilterSectionCollection = ()=>
    _.flatMap(this.state.calendarData.courses, course =>
      _.map(course.sections, section => ( {value: section.id, label: section.name}))
    )
  getFilterStudentCollection = ()=>
    _.orderBy(
      _.flatten(_.flatMap(this.state.calendarData.courses, course =>
        _.map(course.sections, section =>
          _.map(section.students, student => ( {value: student.id, label: student.profile.firstName + " " + (student.profile.lastName ? student.profile.lastName: "") + " (from " + section.name + ")"}))
        )
    )), student => [ student.label.split(' ')[1] ? student.label.split(' ')[1].toUpperCase() : null, student.label.split(' ')[0].toUpperCase() ])

  getFilterContentTypes = ()=>
    [
      {value: 'storyline', label: 'Storyline Quest'},
      {value: 'practice', label: 'Practice Quest'},
      {value: 'enrichment', label: 'Enrichment Quest'},
      {value: 'sandbox-unlock', label: 'Sandbox Unlock'},
      {value: 'expedition', label: 'Expedition'}
    ]

  filterToggleCourseId = id => {
    this.setState({filterSelectedCourseIds: toggleValueInList(parseInt(id), this.state.filterSelectedCourseIds)})
  }
  filterToggleSectionId = id => {
    this.setState({filterSelectedSectionIds: toggleValueInList(parseInt(id), this.state.filterSelectedSectionIds)})
  }
  filterToggleStudentId = id => {
    this.setState({filterSelectedStudentIds: toggleValueInList(parseInt(id), this.state.filterSelectedStudentIds)})
  }
  filterToggleContentType = type => {
    this.setState({filterSelectedContentTypes: toggleValueInList(type, this.state.filterSelectedContentTypes)})
  }

  filterToggleCommittedCourseId = id => {
    const newCourseIds = toggleValueInList(parseInt(id), this.state.filterSelectedCourseIds)
    this.setState((state)=>{
      this.fetchCalendarData(newCourseIds, state.filterCommittedSectionIds, state.filterCommittedStudentIds, state.filterCommittedContentTypes, state.meMode)
      return{filterSelectedCourseIds: newCourseIds, filterCommittedCourseIds: newCourseIds}
    })
  }
  filterToggleCommittedSectionId = id => {
    const newSectionIds = toggleValueInList(parseInt(id), this.state.filterSelectedSectionIds)
    this.setState((state)=> {
      this.fetchCalendarData(state.filterCommittedCourseIds, newSectionIds, state.filterCommittedStudentIds, state.filterCommittedContentTypes, state.meMode)
      return {filterSelectedSectionIds: newSectionIds, filterCommittedSectionIds: newSectionIds}
    })
  }
  filterToggleCommittedStudentId = id => {
    const newStudentIds = toggleValueInList(parseInt(id), this.state.filterSelectedStudentIds)
    this.setState((state)=>{
      this.fetchCalendarData(state.filterCommittedCourseIds, state.filterCommittedSectionIds, newStudentIds, state.filterCommittedContentTypes, state.meMode)
      return {filterSelectedStudentIds: newStudentIds, filterCommittedStudentIds: newStudentIds}
    })
  }
  filterToggleCommittedContentType = type => {
    const newContentTypes = toggleValueInList(type, this.state.filterSelectedContentTypes)
    this.setState((state)=>{
      this.fetchCalendarData(state.filterCommittedCourseIds, state.filterCommittedSectionIds, state.filterCommittedStudentIds, newContentTypes, state.meMode)
      return {filterSelectedContentTypes: newContentTypes, filterCommittedContentTypes: newContentTypes}
    })
  }

  commitFilters = () => {
    this.setState((state)=>{
      this.fetchCalendarData(state.filterSelectedCourseIds, state.filterSelectedSectionIds, state.filterSelectedStudentIds, state.filterSelectedContentTypes, state.meMode)
      return{
        filterCommittedCourseIds: this.state.filterSelectedCourseIds,
        filterCommittedSectionIds: this.state.filterSelectedSectionIds,
        filterCommittedStudentIds: this.state.filterSelectedStudentIds,
        filterCommittedContentTypes: this.state.filterSelectedContentTypes
      }
    })
  }
  revertFilters = () => {
    this.setState({
      filterSelectedCourseIds: this.state.filterCommittedCourseIds,
      filterSelectedSectionIds: this.state.filterCommittedSectionIds,
      filterSelectedStudentIds: this.state.filterCommittedStudentIds,
      filterSelectedContentTypes: this.state.filterCommittedContentTypes
    })
  }

  setSelectedAssignmentGrouping = assignments => {
    this.setState((state)=>{
      if(assignments.contentType === 'expedition'){
        return {
          infoPanelData: assignments,
          sidebarLoaded: true,
          calendarErrors: [],
          selectedAssignmentGrouping: assignments,
          selectedDate: assignments.assignedAt,
          showInfoPanel: true
        }
      }
      else{
        const selectedQuestId = assignments.assignments[0].questId //sandbox_unlock and regular quests should both have questId
        const selectedSequenceId = (assignments.contentType === 'storyline' ? assignments.assignments[0].sequenceId : null)
        this.fetchInfoPanelData(selectedQuestId, assignments.assignedAt, selectedSequenceId, this.state.meMode)
        return {selectedAssignmentGrouping: assignments, selectedDate: assignments.assignedAt, showInfoPanel: true}
      }
    })
  }

  formatDefaultAssignees = (selectedAssignments) => {
    let defaultAssignees = []
    const noCompletedAssignments = _.filter(selectedAssignments, a => _.isEmpty(a.completedAt))
    const formattedAssignments = _.groupBy(noCompletedAssignments, assignment => (assignment.sectionAssignment || {}).sectionId)
    const filterSectionIds = this.state.filterCommittedSectionIds
    const filterStudentIds = this.state.filterCommittedStudentIds
    const filtersEmpty =  _.isEmpty(filterSectionIds) && _.isEmpty(filterStudentIds)

    function isFilteredAssignee(filterIds, assigneeId) {
      return filtersEmpty || _.includes(filterIds, assigneeId)
    }

    _.map(formattedAssignments, (value, key)=> {
      if((!(key === 'undefined' || key === 'null'))){
        if (isFilteredAssignee(filterSectionIds, parseInt(key))) { defaultAssignees.push("section" + key) }
        else {
          _.map(value, assignment => {
            if(isFilteredAssignee(filterStudentIds, assignment.studentId)) { defaultAssignees.push("student" + assignment.studentId)}
          })
        }
      }
      else {
        _.map(value, assignment => {
          if(_.isNumber(assignment.studentId)) {
            if (isFilteredAssignee(filterStudentIds, assignment.studentId)) { defaultAssignees.push("student" + assignment.studentId) }
          } else if(assignment.userId === this.props.currentUser.uuid) {
            defaultAssignees.push('myself')
          } else {
            console.log('debug: somehow received an assignment that is neither a self nor a student assignment')
          }
        })
      }
    })
    return defaultAssignees
  }

  //Popup-related callbacks
  handleQuestClick = (quest) => {
    this.setState((state) => {
      return{
        isAssignmentPopupVisible: true,
        popupQuestData: quest,
        usingDeletionForm: false,
        defaultAssignees: this.formatDefaultAssignees(state.selectedAssignmentGrouping.assignments)
      }
    })
  }

  handlePopupClose = () => {
    this.setState((state)=> {
      this.fetchCalendarData(this.state.filterCommittedCourseIds, this.state.filterCommittedSectionIds, this.state.filterCommittedStudentIds, this.state.filterCommittedContentTypes, this.state.meMode)
      return {
        isAssignmentPopupVisible: false,
        usingDeletionForm: false,
        popupQuestData: {}
      }
    })
  }

  handleAssignmentChange = () => {
    this.fetchCalendarData(this.state.filterCommittedCourseIds, this.state.filterCommittedSectionIds, this.state.filterCommittedStudentIds, this.state.filterCommittedContentTypes, this.state.meMode)
  }

  handleButtonFetch = (selectedAssignments, usingDeletionForm) => {
    this.fetchAssignmentPopupData(selectedAssignments, usingDeletionForm)
  }

  handleToggleMeMode = ()=> {
    this.fetchCalendarData(
      this.state.filterCommittedCourseIds,
      this.state.filterCommittedSectionIds,
      this.state.filterCommittedStudentIds,
      this.state.filterCommittedContentTypes,
      !this.state.meMode
    )

    this.setState({
      meMode:         !this.state.meMode,
      infoPanelData:  {},
      showInfoPanel:  false
    })

  }

  clearDeletePriorState = ()=>{
    this.setState({
      deletePriorCount: '',
      deletePriorErrors: []
    })
  }

  closeInfoPanel = ()=>{
    this.setState({showInfoPanel: false, selectedAssignmentGrouping: {}})
  }

//Boolean that returns wether or not the selected tag is on the left half of the calendar.
//Note: this method is currently only calibrated for its use case, specifically when the
//Calendar takes up the entire window, and the info panels show over the calendar.
  selectedTagOnLeftSide = ()=>{
    if(_.isEmpty(this.selectedTagElement.current)){ return null }

    else {
      return this.selectedTagElement.current.getBoundingClientRect().x < window.innerWidth / 2}
  }

//onboarding guide context => the same as useContext in functional components
  static contextType = OnboardingTeacherContext

  render() {
    return(
      <div className='calendar-page'>
        <ImageHeader image={calendarHeaderImage} titleContents='Calendar'>
          <FilterBanner
            courseCollection={this.getFilterCourseCollection()}
            sectionCollection={this.getFilterSectionCollection()}
            studentCollection={this.getFilterStudentCollection()}
            contentTypes={this.getFilterContentTypes()}
            selectedCourseIds={this.state.filterSelectedCourseIds}
            selectedSectionIds={this.state.filterSelectedSectionIds}
            selectedStudentIds={this.state.filterSelectedStudentIds}
            selectedContentTypes={this.state.filterSelectedContentTypes}
            committedCourseIds={this.state.filterCommittedCourseIds}
            committedSectionIds={this.state.filterCommittedSectionIds}
            committedStudentIds={this.state.filterCommittedStudentIds}
            committedContentTypes={this.state.filterCommittedContentTypes}
            toggleCourseId={this.filterToggleCourseId}
            toggleSectionId={this.filterToggleSectionId}
            toggleStudentId={this.filterToggleStudentId}
            toggleContentType={this.filterToggleContentType}
            toggleCommittedCourseId={this.filterToggleCommittedCourseId}
            toggleCommittedSectionId={this.filterToggleCommittedSectionId}
            toggleCommittedStudentId={this.filterToggleCommittedStudentId}
            toggleCommittedContentType={this.filterToggleCommittedContentType}
            onApply={this.commitFilters}
            onCancel={this.revertFilters}
            hasDateFilter={false}
            hasContentFilter={true}
            showMeModeToggle={true}
            onToggleMeMode={this.handleToggleMeMode}
            meMode={this.state.meMode}
          />
          {!this.context.isAllComplete && <div style={{'marginBottom':'32px'}}><OnboardingGuideBanner /></div>}
          <div className='calendar-wrapper'>
            <div className='content-wrapper'>
              <Calendar
                selectedAssignmentIsSandbox={(this.getSidebarAssignments() || {}).isSandbox}
                uniqueAssignments={this.getCalendarAssignments(
                  this.state.calendarData,
                  this.state.filterCommittedCourseIds,
                  this.state.filterCommittedSectionIds,
                  this.state.filterCommittedStudentIds,
                  this.state.filterCommittedContentTypes
                )}
                selectedDate={this.state.selectedDate}
                selectedAssignments={this.state.selectedAssignmentGrouping}
                selectedTagRef={this.selectedTagElement}
                setSelectedAssignment={this.setSelectedAssignmentGrouping}
                deletePriorAssignments={this.deletePriorAssignments}
                deletePriorLoading = {this.state.deletePriorLoading}
                deletePriorErrors={this.state.deletePriorErrors}
                deletePriorCount={this.state.deletePriorCount}
                clearDeletePriorState={this.clearDeletePriorState}
                handleMakeChangesOrDeleteClick={this.handleButtonFetch}
                fetchCalendarData={this.handleAssignmentChange}
                numberOverflowing={this.numberOverflowing}
                filterCommittedCourseIds={this.state.filterCommittedCourseIds}
                filterCommittedSectionIds={this.state.filterCommittedSectionIds}
                filterCommittedStudentIds={this.state.filterCommittedStudentIds}
                filterCommittedContentTypes={this.state.filterCommittedContentTypes}
                meMode={this.state.meMode}
              />
              <div className='calendar-legend'>
                <div className='legend-box'>
                  <LegendPills color='#00C8E4' linkCount={3}/>
                  <p>= storyline quests</p>
                </div>
                <div className='legend-box'>
                  <LegendPills color='#7620C6' linkCount={1}/>
                  <p>= practice quests</p>
                </div>
                <div className='legend-box'>
                  <LegendPills color='#4FCA15' linkCount={1}/>
                  <p>= enrichment quests</p>
                </div>
                <div className='legend-box'>
                  <LegendPills color='#F84891' linkCount={1}/>
                  <p>= sandbox unlocking quests</p>
                </div>
                <div className='legend-box'>
                  <LegendPills color='#4F5B66' linkCount={1}/>
                  <p>= expedition quests</p>
                </div>
              </div>
            </div>
              <div className='info-panels-wrapper'>
                {this.state.showInfoPanel ?
                  <QuestInfoPanel
                    sidebarAssignments={this.getSidebarAssignments()}
                    handleShowAssignmentPopup={this.handleQuestClick}
                    sidebarLoaded={this.state.sidebarLoaded}
                  /> : <ImageEmptyState
                    src={tippsGreetingImage}
                    imageProps={{ style: { maxWidth: '256px' } }}
                    text="Select an assignment to see details."
                  />
                }

                {this.state.showInfoPanel && !_.isEmpty(this.getSidebarAssignments().selectedSelfAssignments) &&
                  <AssignmentInfoPanel type={'self'}/>
                }
                {(this.state.showInfoPanel && !_.isEmpty(this.getSidebarAssignments().selectedClassAssignments)) &&
                  _.map(this.getSidebarAssignments().selectedClassAssignments, assignment =>{
                    return <AssignmentInfoPanel key={assignment.id} assignmentData={assignment} type={'class'}/>}
                  )
                }
                {(this.state.showInfoPanel && !_.isEmpty(this.getSidebarAssignments().selectedIndividualAssignments)) &&
                  <AssignmentInfoPanel assignmentData={this.getSidebarAssignments().selectedIndividualAssignments} type={'individual'}/>
                }
              </div>
              {this.state.showInfoPanel &&
                <div className={'smaller-info-panels-wrapper'+ (this.selectedTagOnLeftSide() ? ' right' : ' left')} >
                  <div onClick={()=>{this.closeInfoPanel()}} className='popup-background'></div>
                  <div className='smaller-info-panels-wrapper_subcontainer'>
                    <QuestInfoPanel
                      sidebarAssignments={this.getSidebarAssignments()}
                      handleShowAssignmentPopup={this.handleQuestClick}
                      sidebarLoaded={this.state.sidebarLoaded}
                    />
                    {!_.isEmpty(this.getSidebarAssignments().selectedSelfAssignments) &&
                      <AssignmentInfoPanel type={'self'}/>
                    }
                    {(!_.isEmpty(this.getSidebarAssignments().selectedClassAssignments)) &&
                      _.map(this.getSidebarAssignments().selectedClassAssignments, assignment =>
                        <AssignmentInfoPanel key={'smaller-info-panels'+ assignment.id} assignmentData={assignment} type={'class'}/>
                      )
                    }
                    {(!_.isEmpty(this.getSidebarAssignments().selectedIndividualAssignments)) &&
                      <AssignmentInfoPanel assignmentData={this.getSidebarAssignments().selectedIndividualAssignments} type={'individual'}/>
                    }
                  </div>
                </div>
              }
          </div>
          {this.state.isAssignmentPopupVisible &&
            <AssignmentPopupContainer
              assignableContent={this.state.popupQuestData}
              studentGroupings={this.state.calendarData.courses}
              handleClose={()=>this.handlePopupClose()}
              onlyUpdateTimestamps={true}
              questId={(this.state.popupQuestData || {}).id}
              defaultAssignees={(this.state.defaultAssignees || [])}
              usingDeletionForm={this.state.usingDeletionForm}
              fetchCalendarData={this.handleAssignmentChange}
              sidebarAssignments={this.getSidebarAssignments(this.state.infoPanelData, this.state.calendarData.courses)}
            />
          }
        </ImageHeader>
      </div>
    )
  }
}



const mapStateToProps = state =>{
  const api = denormalize(state.api || {})
  return{
    ...state.calendar
  }
}
export default connect(mapStateToProps)(CalendarContainer)
